<template>
  <div id="partner-container">
    <img
      class="partners-logo"
      v-for="partner in pArray"
      :key="partner.id"
      :src="`${API}/partners/images/${partner.image}`"
      :alt="partner.name"
    >
  </div>
</template>

<script>
const API_REFERENCE = require('../../api').api_v1;

export default {
  name: 'PartnersGrid',
  props: { pArray: Array },
  data() {
    return {
      API: API_REFERENCE,
    };
  },
};
</script>

<style scoped lang="scss">
  .partners-logo {
    width: 100px;
    margin: 15px;
  }

  #partner-container {
    padding: 15px 25px 30px 25px;
  }
</style>
